import { useSelector, useDispatch } from 'react-redux';
import styles from './Product.module.css';
import arrows from './assets/arrows.svg';
import selected from './assets/selected.svg';
import block from './assets/block.png';

export default function Product({ focus, product, size, onSelect,  isActive,collectionFilterColumnName}) {
     const activeProductMenuTab = useSelector(state => state.visualizer.activeProductMenuTab);
    return (
        <li
            className={`${styles.product} ${isActive ? styles.active+' selectedProduct' : ''}`}
            data-id={product.id}
            onClick={() => {
                onSelect(product);
            }}
        >
                 {activeProductMenuTab == 'wall color' ? (
                    <>
                        <div className={styles.imgWrapper}>
                            <img
                                loading="lazy"
                                style={{
                                    backgroundColor: product.specifier.replace("COLOR(", "").replace(")", "")
                                }}
                                src={block}
                                alt={`Product - ${product.id}`}
                            />
                             <div className={styles.activeContent}>
                                {/* <div className={styles.selectBox}>
                                <span src={selected}>selected</span> </div> */}
                                <img src={selected} className={styles.selectedImg} width="96" height="69" />
                            </div>
                        </div>
                        <div className={styles.productInfo}>
                            <div className={styles.title}>{product.name}</div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className={styles.imgWrapper}>
                            <img
                                loading="lazy"
                                src={`https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=${product.specifier}&type=prod&extra=(focus=${focus})&Size=${size}&csize=${size}`}
                                alt={`Product - ${product.id}`}
                            />
                             <div className={styles.activeContent}>
                                {/* <div className={styles.selectBox}>
                                <span src={selected}>selected</span> </div> */}
                                <img src={selected} className={styles.selectedImg} width="96" height="69" />
                            </div>
                        </div>
                        <div className={styles.productInfo}>
                            <div className={styles.title}>{product.color}</div>
                            <div className={styles.description}>{product[collectionFilterColumnName]}</div>
                            <div className={styles.description}>{product.warranty}</div>
                        </div>
                    </>
                )}
                     
        </li>
    );
}
